(function (module) {
    'use strict';

    function AddIntegrationCtrl(_, Popup, $scope, $state, envService, IntegrationTemplate, Store, Integration, Includes) {
        this.$onInit = () => {
            IntegrationTemplate
                .find()
                .$promise
                .then((integrationTemplates) => {
                    this.integrationTemplates = _.reject(integrationTemplates, ({ provider }) => provider.startsWith('rocket-'));
                });
        };

        this.connect = () => {
            const UI_URI = envService.read('UI_URI');
            const config = {
                url: `${UI_URI}/social/${this.integrationTemplate.provider}/${this.integrationTemplate.id}`,
                redirectUri: `${UI_URI}/social/${this.integrationTemplate.provider}/callback`,
                popupOptions: {
                    width: 900,
                    height: 600,
                },
            };

            Popup
                .open(config)
                .then(({ id }) => {
                    return Integration.findById({ id, filter: Includes.integrations }).$promise;
                })
                .then((integration) => {
                    return Store.setSingleModelData('integrations', integration.id, integration);
                })
                .then((integration) => {
                    $state.go('root.integrations.edit-integration', { id: integration.id });
                });
        };

    }

    module
        .config(($stateProvider, $translatePartialLoaderProvider) => {
            $stateProvider
                .state('root.integrations.add', {
                    url: '/add',
                    data: {
                        pageTitle: 'PLAYERS_ADD.PAGE_TITLE',
                    },
                    views: {
                        'content@root': {
                            template: '<integration-add-component/>',
                        },
                    },

                });

            $translatePartialLoaderProvider.addPart('/js/integrations');

        })
        .component('integrationAddComponent', {
            templateUrl: '/js/integrations/add-integration/add-integration.html',
            controller: AddIntegrationCtrl,
        });

})(angular.module('rocket.components'));
